import { render, staticRenderFns } from "./game-wrapper.vue?vue&type=template&id=cbf08170&scoped=true"
import script from "./game-wrapper.vue?vue&type=script&lang=js"
export * from "./game-wrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbf08170",
  null
  
)

export default component.exports